import React from "react";
import { Button, Modal, Form, Input, Select, Space } from "antd";
import { UserModalProps } from "../../types/user";

const { Option } = Select;

const UserModal: React.FC<UserModalProps> = ({
  visible,
  form,
  onFinish,
  onCancel,
  editingRecord,
}) => {
  return (
    <Modal
      title={editingRecord ? "Chỉnh sửa người dùng" : "Thêm người dùng"}
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={600}
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <div style={{ display: "flex", gap: "16px" }}>
          <Form.Item
            name="firstName"
            label="Tên"
            rules={[{ required: true, message: "Tên không được để trống" }]}
            style={{ flex: 1 }}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="lastName"
            label="Họ"
            rules={[{ required: true, message: "Họ không được để trống" }]}
            style={{ flex: 1 }}
          >
            <Input />
          </Form.Item>
        </div>

        <Form.Item
          name="email"
          label="Email"
          rules={[
            { required: true, message: "Email không được để trống" },
            { type: "email", message: "Định dạng email không hợp lệ" },
          ]}
        >
          <Input autoComplete="new-email" />
        </Form.Item>

        <Form.Item
          name="password"
          label="Mật khẩu"
          rules={[
            // Khi sửa: để trống = giữ mật khẩu cũ; nếu nhập thì API vẫn yêu cầu mật khẩu mạnh
            ...(editingRecord
              ? []
              : [{ required: true, message: "Mật khẩu không được để trống" }]),
            {
              min: 8,
              message: "Mật khẩu phải có ít nhất 8 ký tự",
            },
            {
              pattern: new RegExp(
                "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}$"
              ),
              message:
                "Mật khẩu phải có ít nhất 8 ký tự, bao gồm 1 chữ cái viết hoa, 1 chữ cái viết thường, 1 số và 1 ký tự đặc biệt (@, $, !, %, *, ?, &)",
            },
          ]}
        >
          <Input.Password
            placeholder={
              editingRecord ? "Để trống nếu không đổi mật khẩu" : "Mật khẩu"
            }
            autoComplete="new-password"
          />
        </Form.Item>

        <Form.Item
          name="role"
          label="Vai trò"
          rules={[{ required: true, message: "Vai trò không được để trống" }]}
        >
          <Select>
            <Option value="admin">Admin</Option>
            <Option value="hr">HR</Option>
          </Select>
        </Form.Item>

        <Form.Item>
          <Space>
            <Button type="primary" htmlType="submit">
              Lưu
            </Button>
            <Button onClick={onCancel}>Huỷ</Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default UserModal;
